import { notification } from 'antd';

const ObjectionMessage = (key, objMsg) => {
  notification.info({
    key,
    message: `Objeción emitida por ${objMsg.author}`,
    description: `${objMsg.message}`,
    duration: null,
    top: 150,
  });
};

export default ObjectionMessage;